// Interface
export interface HomeComponent {
  componentsData: string
}
export interface HomeData {
  groupList: any[]
  isSign: boolean
  homeComponent: HomeComponent
  componentList: any[]
  componentIdsInOrderConfig: any
  isPWA: boolean
  isShowingPWA: boolean
}
export interface BannerItem {
  display: boolean,
  redirectUrl: string
  url: string
}

// Constant
export const HOME_COMPONENT_ID = {
  header: 1,
  banners: 2,
  notice: 3,
  newsBar: 4,
  gameGroups: 5,
  AppDownload: 6,
  shareMedia: 7,
  footerText: 8,
  footer: 9,
  contactService: 10,
  providers: 11,
  copyrightText: 12,
}

export interface GameList {
  customIcon: string,
  id: number | string,
  gameId: number | string,
  gameMakerId: number | string,
  isFavorite: number,
  activeGameId: any
}
export interface GameGroupData {
  gamesGrid: {
    rowCount: number,
    columnCount: number
  },
  styles: {
    active_font_color: string,
    border_color: string,
  }
}
export interface BannerItem {
  url: string,
  redirectUrl: string,
  display: boolean
}

export interface GroupList {
  name: string,
  showName: string,
  customIcon: string,
  id: number | string,
  groupType: number,
}
export interface MediaItem {
  display: boolean,
  redirectUrl: string,
  url: string
}
export interface PartnerList {
  img: string,
  id: number | string
}

export interface PwaOptions {
  url: string
  token?: string | null
  clientId?: string
  tenantId?: string
  isIos?: boolean
  iosPopupRef?: Ref<boolean>
  emitInstall?: () => void
}

export interface FooterImagesItem {
  display: boolean
  url: string
  redirectUrl: string
}

interface GameListResult {
  rows: any[]
  total: number
}
// 
export const TAB_LIST = [
  { id: 1, name: 'common.toLookFor', icon: require('@/assets/themeThree/search.png') },
  { id: 2, name: 'games.popular', icon: require('@/assets/themeThree/POPULAR_on.png') },
  { id: 3, name: 'games.recent', icon: require('@/assets/themeThree/RECENT_on.png') },
  { id: 4, name: 'games.favorite', icon: require('@/assets/themeThree/favorite.png') },
]
export const TAB_LIST_THEME4 = [
  { id: 1, name: 'common.toLookFor', icon: 'search' },
  { id: 2, name: 'games.popular', icon: 'fire' },
  { id: 3, name: 'games.recent', icon: 'todo-list' },
  { id: 4, name: 'games.favorite', icon: 'gem' },
]
// Function
import { useRouter } from 'vue-router'
import { Ref } from 'vue'
import { Router } from 'vue-router'
import { Share } from '@capacitor/share'
import { playClickSound } from '@/utils/media'
import { getAllGame, getGameListForSearch } from '@/api/common'
import { useThemeStore } from '@/stores/theme'

export function useNavigation() {
  const router = useRouter()

  const goToPath = (path: string) => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    router.push(path)
  }

  return { goToPath }
}

export function goToLink(path: string) {
  if (process.env.VUE_APP_PREVIEW_MODE == 'true') return

  if (!path) return
  window.open(path, '_blank')
}

export function goToActivityPath(
  name: string,
  router: Router,
  handleShowTreasurePopup?: any,
  emits?: (event: 'openAgentPopup' | 'openRedEnvelop' | 'goToHome' | 'openPWA' | 'openMisteryBoxPopup', ...args: any[]) => void
) {
  if (process.env.VITE_APP_PREVIEW_MODE === 'true' || process.env.VUE_APP_PREVIEW_MODE === 'true') return
  const themeStore = useThemeStore()
  switch (name) {
    case 'user_referral_reward':
      router.push('/sdagency')
      break
    case 'lucky_wheel':
      router.push('/cashwheel')
      break
    case 'recharge_bargain_sales':
      router.push('/sdbigdep')
      break
    case 'agent_cash_back':
      emits?.('openAgentPopup')
      break
    case 'vip_reward':
      router.push('/sd-vip')
      break
    case 'red_envelope_rain':
      emits?.('openRedEnvelop')
      break
    case 'game_benefit':
      router.push('/lossRelief')
      break
    case 'mystery':
      router.push('/sdmystery')
      break
    case 'user_rank':
      router.push('/sd-level')
      break
    case 'first_recharge':
      router.push('/firstRecharge')
      break
    case 'recharge_gift':
      router.push('/rechargeGift')
      break
    case 'return_turnover':
      router.push('/returnTrunover')
      break
    case 'daily_first_recharge':
      router.push('/firstDeposit')
      break
    case 'signin_rewards':
      router.push('/checkinRewards')
      break
    case 'pwa_reward':
      emits?.('openPWA')
      break
    case 'active_tresure_chest':
      router.push('/sdactivechest')
      break
    case 'redeem_code':
      console.log('call');

      router.push('/giftCode')
      break
    case 'active_bonus':
      router.push('/activeBonus')
      break
    case 'login_treasure_chest':
      handleShowTreasurePopup('login_treasure_chest')
      break
    case 'next_day_treasure_chest':
      handleShowTreasurePopup('next_day_treasure_chest')
      break
    case 'return_treasure_chest':
      handleShowTreasurePopup('return_treasure_chest')
      break
    case 'daily_treasure_chest':
      handleShowTreasurePopup('daily_treasure_chest')
      break
    case 'admin_recharge':
      handleShowTreasurePopup('admin_recharge')
      break
    case 'mystery_box':
      themeStore.themeIndex === 1 || themeStore.themeIndex === 3 ? router.push('/misteryBox') : emits?.('openMisteryBoxPopup')
      break
    default:
      router.push('/')
      break
  }
}

export const openRegisterPopup = (
  openRegisterLoginPopup: ((type: number) => void) | undefined,
  type: number
) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  openRegisterLoginPopup?.(type)
}

export const goToPlayGame = (
  router: Router,
  openRegisterLoginPopup: ((type: number) => void) | undefined,
  id: string | number,
  makerId: string | number,
  favorite: string | number,
  favId: string | number,
) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  const token = localStorage.getItem('token')
  if (token) {
    router.push({ path: '/pgame', query: { game_type: id, game_maker: makerId, favorite: favorite, fav_id: favId } })
  } else {
    openRegisterLoginPopup?.(1)
  }
}

export const setFirstActiveItem = <T extends { id: string | number }>(
  list: T[],
  activeRef: Ref<string | number>
) => {
  activeRef.value = list[0]?.id || ''
}

export const setActiveItemFromClick = <T extends { id: string | number }>(
  item: T,
  activeRef: Ref<string | number>
) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  activeRef.value = item.id
}

export const emitWithPreviewCheck = (
  emitsFn: (...args: any[]) => void,
  eventName: string,
  payload?: any
) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  emitsFn(eventName, payload)
}

export const goToShare = async (path: string) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  if (!path) return

  try {
    await Share.share({
      text: path,
    })
  } catch (err) {
    console.error('Failed to share:', err)
  }
}

export const openPopup = (popupRef: any) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return;
  popupRef?.value?.openPopup?.();
}

export const safeNavigate = (router: Router, path: string, stopEvent?: Event) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return;
  playClickSound();
  stopEvent?.stopPropagation?.();
  router.push(path);
}

export const installPWA = (options: PwaOptions) => {

  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return

  const token = localStorage.getItem('token')
  const clientId = process.env.VUE_APP_CLIENT_ID
  const tenantId = process.env.VUE_APP_BASE_TENANT_ID ?? "000000"
  const { url, isIos, iosPopupRef, emitInstall } = options

  if (!url) {
    if (isIos && iosPopupRef) {
      iosPopupRef.value = true
    } else if (emitInstall) {
      emitInstall()
    }
    return
  }

  if (token) {
    const redirectUrl = `${url}?token=${encodeURIComponent(token)}&clientId=${encodeURIComponent(clientId)}&tenantId=${encodeURIComponent(tenantId) ?? '000000'}`
    window.open(redirectUrl, '_blank')
  } else {
    window.open(url, '_blank')
  }
}

export const checkIosPWAInstallable = () => {
  const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone
  return isIOS && isSafari && !isStandalone
}

export const fetchGameList = async (pageNum: number, pageSize: number, searchText: string, groupId?: string): Promise<GameListResult> => {
  const params: any = { pageNum, pageSize, searchText }
  params.groupId = groupId || ''

  try {
    const res = await getAllGame(params)
    return {
      rows: res.data?.rows || [],
      total: res.data?.total || 0,
    }
  } catch (err) {
    console.error('Error fetching game list:', err)
    return { rows: [], total: 0 }
  }
}
export function debounce<T extends (...args: any[]) => void>(fn: T, delay = 500) {
  let timer: ReturnType<typeof setTimeout> | undefined

  return (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

export const getGameSpecialCategories = async () => {
  try {
    const res = await getGameListForSearch()
    return {
      favoriteGameList: res.data?.favoriteGameList || [],
      hotGameList: res.data?.hotGameList || [],
      recentGameList: res.data?.recentGameList || [],
    }
  } catch (err) {
    console.error('Error fetching game list:', err)
    return {
      favoriteGameList: [],
      hotGameList: [],
      recentGameList: [],
    }
  }
}
